import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type AvatarProofCtaProps = CtaShellProps

export function AvatarProofCta(props: AvatarProofCtaProps) {
  return <CtaShell {...props} layout="centered" socialProof={props.socialProof ?? { avatars: [{ fallback: "AR" }, { fallback: "MK" }, { fallback: "JS" }, { fallback: "TN" }], count: "12,400+ teams launched from this path" }} />
}
